import React, { Dispatch, SetStateAction, useMemo } from 'react';
import NavigatorImagingSettings from './NavigatorImagingSettings';
import NavigatorInspections from './NavigatorInspections';
import './navigator.scss';
import NavigatorRegions from './NavigatorRegions';
import NavigatorDrops from './NavigatorDrops';
import { ITabItem } from 'components/tab';
import RMTabs from 'components/customComponents/Controls/RMTabs';
import { IStyle } from 'Styles';
import { DropImageParameters, WellNavigationDetails } from 'components/Experiment/constants';

export interface NavigatorProps {
  setMoveToCanvas: any;
  roi?: any,
  wellNavigationDetails: WellNavigationDetails,
  dropImageParameters: DropImageParameters,
}
interface Props {
  expId: number,
  setMoveToCanvas: Dispatch<SetStateAction<boolean>>,
  thTabIndex: number,
  changeThTabIndex: (index: number) => void,
  roi: any,
  wellNavigationDetails: WellNavigationDetails,
  dropImageParameters: DropImageParameters,
}
export default function NavigatorThumbnail(props: Props) {
  const {expId, setMoveToCanvas, roi, wellNavigationDetails, dropImageParameters} = props;
  const tabComponents: ITabItem[] = useMemo(
    () => [
      {
        id:'navigatorthumbnail-inspections',
        title: 'Inspections',
        eventKey: 'Inspections',
        content: (
          <NavigatorInspections setMoveToCanvas={setMoveToCanvas} wellNavigationDetails={wellNavigationDetails} dropImageParameters={dropImageParameters} />
        ),
        iconProps: {
          id:'navigatorthumbnail-iconprops-inspections',
          name: 'Inspections',
          fill: 'black',
          style: styles.iconPropsStyle,
          height: 18,
          width: 18,
        },
      },
      {
        id:'navigatorthumbnail-settings',
        title: 'Settings',
        eventKey: 'Settings',
        content: (
          <NavigatorImagingSettings setMoveToCanvas={setMoveToCanvas} wellNavigationDetails={wellNavigationDetails} dropImageParameters={dropImageParameters} />
        ),
        iconProps: {
          id:'navigatorthumbnail-iconprops-imagingsettings',
          name: 'ImagingSettings',
          fill: 'black',
          style: styles.iconPropsStyle,
          height: 18,
          width: 18,
        },
      },
      {
        id:'navigatorthumbnail-region',
        title: 'Region',
        eventKey: 'Region',
        content: (
          <NavigatorRegions roi={roi} setMoveToCanvas={setMoveToCanvas} wellNavigationDetails={wellNavigationDetails} dropImageParameters={dropImageParameters} />
        ),
        iconProps: {
          id:'navigatorthumbnail-iconprops-region',
          name: 'Region',
          fill: 'black',
          style: styles.iconPropsStyle,
          height: 18,
          width: 18,
        },
      },
      {
        id:'navigatorthumbnail-drop',
        title: 'Drop',
        eventKey: 'Drop',
        content: <NavigatorDrops setMoveToCanvas={setMoveToCanvas} wellNavigationDetails={wellNavigationDetails} dropImageParameters={dropImageParameters} />,
        iconProps: {
          name: 'Drop',
          fill: 'black',
          style: styles.iconPropsStyle,
          height: 18,
          width: 18,
        },
      },
    ],
    [dropImageParameters, roi, wellNavigationDetails],
  );
  const tabs = expId ? (
    <RMTabs id='navigatorthumbnail-tabs' tabItems={tabComponents} defaultActiveKey={'Inspections'} />
  ) : (
    <></>
  );
  return (
    <div id='navigatorthumbnail-container' className="container-fluid p-0 border" style={styles.container}>
      <div id='navigatorthumbnail-row' className="row">
        <div id={`navigatorthumbnail-${tabs}`} className="col-md-12">{tabs}</div>
      </div>
    </div>
  );
}

const styles: IStyle = {
  container: {
    height: '100%',
  },
  iconPropsStyle: {
    marginRight: '3%',
    marginBottom: '5%',
  },
};
